import type { Dispatch, FC, SetStateAction } from 'react';

import { Chip } from '@/core/tamagoshi/Chip/Chip';
import { Text } from '@/core/tamagoshi/Text/Text';
import type { DetailMdScore } from '@/domains/productDiscovery/ArticleReviews/ArticleReviews.model';

import styles from './playlistTitle.module.scss';

interface Props {
  text: string;
  subtitle: string;
  mds: DetailMdScore[];
  selectedMd?: DetailMdScore;
  setSelectedMd: Dispatch<SetStateAction<DetailMdScore | undefined>>;
}

export const PlaylistTitle: FC<Props> = ({
  text,
  subtitle,
  mds,
  selectedMd,
  setSelectedMd,
}) => (
  <div className={styles.container}>
    <Text tag="span" type="h4" weight="bold" className={styles.title}>
      {text}
    </Text>
    <div className={styles.list}>
      {mds.map((md) => (
        <Chip
          key={md.questionId}
          data-testid="select-md"
          onClick={() => setSelectedMd(md)}
          theme="outline"
          selected={selectedMd?.questionId === md.questionId}
        >
          {md.name}
        </Chip>
      ))}
    </div>
    <Text className={styles.subtitle}>{subtitle}</Text>
  </div>
);

PlaylistTitle.displayName = 'PlaylistTitle';
